module.exports = __webpack_public_path__ + "static/media/tennis-ball.90ff27e1.svg";